import { __decorate } from "tslib";
import { AsnType, AsnTypeTypes, AsnProp } from "@peculiar/asn1-schema";
import { Certificate } from "@peculiar/asn1-x509";
import { IssuerAndSerialNumber } from "@peculiar/asn1-cms";
export const id_at_statementOfPossession = "1.3.6.1.4.1.22112.2.1";
let PrivateKeyPossessionStatement = class PrivateKeyPossessionStatement {
    constructor(params = {}) {
        Object.assign(this, params);
    }
};
__decorate([
    AsnProp({ type: IssuerAndSerialNumber })
], PrivateKeyPossessionStatement.prototype, "signer", void 0);
__decorate([
    AsnProp({ type: Certificate, optional: true })
], PrivateKeyPossessionStatement.prototype, "cert", void 0);
PrivateKeyPossessionStatement = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], PrivateKeyPossessionStatement);
export { PrivateKeyPossessionStatement };
